export enum StatusVariantColor {
  Green = 'green',
  Ordinary = 'ordinary',
  Red = 'red',
  Blue = 'blue',
  Yellow = 'yellow',
  Casual = 'casual',
}
